/**
 * 登录 Token 读取 — standalone 模块。
 *
 * 本文件被标记为 standalone，表示它**不依赖** request 层的重模块（拦截器、store 等），
 * 仅依赖叶子节点 `@/constants/storage-key`，因此可被任意目录安全引用，不会引发循环依赖。
 *
 * 跨目录引用方：
 *   - `@/request/interceptors` — 请求拦截器注入 Authorization header
 *   - `@/store/user` — 用户状态初始化时预取 token
 *   - `@/service/project-timezone` — 时区初始化独立请求携带 token
 */
import { USER_TOKEN_KEY } from '@/constants/storage-key';

/** 从 localStorage 获取当前用户的登录 Token */
export const getAuthToken = (): string | null => localStorage.getItem(USER_TOKEN_KEY);
